
import { useState } from 'react';
import { InstagramPost } from '@/types/instagram';

export const useInstagramState = () => {
  const [posts, setPosts] = useState<InstagramPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [lastUpdate, setLastUpdate] = useState<string | null>(null);

  const updatePosts = (newPosts: InstagramPost[], updateTime: string) => {
    setPosts(newPosts);
    setLastUpdate(updateTime);
    setError(null);
  };

  const setErrorMessage = (err: Error) => {
    console.error('❌ Erro ao buscar posts:', err);
    
    // Mensagens de erro mais específicas
    let errorMessage = err.message;
    if (err.name === 'TimeoutError') {
      errorMessage = 'Timeout: API demorou para responder (Render pode estar "dormindo")';
    } else if (err.message.includes('fetch')) {
      errorMessage = 'Erro de conexão com a API';
    }
    
    setError(errorMessage);
  };

  return {
    posts,
    loading,
    error,
    lastUpdate,
    setLoading,
    updatePosts,
    setErrorMessage
  };
};
